import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { CONTACT_DEPARTMENTS, DEFAULT_DEPARTMENT } from '../../config/contactDepartments';
import './styles.css';

const API_URL = `${import.meta.env.VITE_URL_API}/contatos`;
const DEFAULT_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb2RpZ28iOjEsIm5vbWUiOiJGaWxpcGUiLCJlbWFpbCI6ImpvdmlweXJhbWlkQGhvdG1haWwuY29tIiwidGlwbyI6MiwiYXRpdm8iOjEsImlhdCI6MTc0NzkzNjM5NywiZXhwIjoxNzQ4NTQxMTk3fQ.KCcq-ZwvK9l-6gFGM5gzgZuCNrIPBaMyvjLpqVj6Lrk';

const Contact = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    name: '',
    email: '',
    department: DEFAULT_DEPARTMENT,
    subject: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        nomeCONTATO: form.name,
        emailCONTATO: form.email,
        departamentoCONTATO: form.department,
        assuntoCONTATO: form.subject,
        mensagemCONTATO: form.message,
        dataENVIO: new Date().toISOString(),
        statusCONTATO: 1
      };
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${DEFAULT_TOKEN}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error(t('contact.form.submitError'));
      try {
        await Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: t('contact.form.submitSuccess'),
          confirmButtonText: 'OK',
        });
      } catch (_) { /* noop */ }
      setForm({ name: '', email: '', department: DEFAULT_DEPARTMENT, subject: '', message: '' });
    } catch (err) {
      try {
        await Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: err?.message || t('contact.form.unexpectedError'),
          confirmButtonText: 'OK',
        });
      } catch (_) { /* noop */ }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="hero-content">
          <h1>{t('contact.hero.title')}</h1>
          <p dangerouslySetInnerHTML={{ __html: t('contact.hero.subtitle') }}></p>
         
        </div>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <div className="info-section">
            <h2>{t('contact.info.title')}</h2>
            <p>{t('contact.info.subtitle')}</p>
            <p></p>
           {/*  <div className="contact-methods">
              <div className="contact-method">
                <i className="fas fa-envelope"></i>
                <h3>E-mail</h3>
                <p>suporte@joviplanet.com</p>
                <p>comercial@joviplanet.com</p>
              </div>
              <div className="contact-method">
                <i className="fas fa-phone"></i>
                <h3>Telefone</h3>
                <p>+351 123 456 789</p>
                <p>Segunda a Sexta, 9h-18h</p>
              </div>
              <div className="contact-method">
                <i className="fas fa-map-marker-alt"></i>
                <h3>Endereço</h3>
                <p>Rua Example, 123</p>
                <p>Lisboa, Portugal</p>
              </div>
            </div> */}
          </div>

          <div className="form-section">
            <h2>{t('contact.form.title')}</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">{t('contact.form.name')}</label>
                <input type="text" id="name" name="name" required value={form.name} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label htmlFor="email">{t('contact.form.email')}</label>
                <input type="email" id="email" name="email" required value={form.email} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label htmlFor="department">{t('contact.form.department')}</label>
                <select id="department" name="department" required value={form.department} onChange={handleChange}>
                  {CONTACT_DEPARTMENTS.map((d) => (
                    <option key={d.key} value={d.key}>{t(`contact.form.departments.${d.key}`)}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="subject">{t('contact.form.subject')}</label>
                <input type="text" id="subject" name="subject" required value={form.subject} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label htmlFor="message">{t('contact.form.message')}</label>
                <textarea id="message" name="message" rows="5" required value={form.message} onChange={handleChange}></textarea>
              </div>
              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? t('contact.form.sending') : t('contact.form.submit')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;